import { Box, Checkbox, TableCell, TableRow, Typography } from '@mui/material';
import { ReactNode } from '@tanstack/react-router';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import ErrorIndicator from 'src/components/atoms/error-indicator';
import { EmployeeInvitationStatus } from 'src/features/employees/types/enum/employee-invitation-status';
import EmployeeInvitationState from '../molecules/employee-invitation-state';

export interface EmployeesActionsSlotPayload {
  token: string;
  email: string;
  employeeGroupToken: string;
}

interface Props {
  token: string;
  email: string;
  status: EmployeeInvitationStatus;
  employeeGroupToken: string;
  groupName?: string;
  actionsSlot: (payload: EmployeesActionsSlotPayload) => ReactNode;
  selectedEmployees: string[];
  toggleSelection: (isChecked: boolean, rowId: string) => void;
}

const EmployeesTableRow: FC<Props> = ({
  token,
  email,
  status,
  employeeGroupToken,
  groupName,
  actionsSlot,
  selectedEmployees,
  toggleSelection,
}) => {
  const { t } = useTranslation();

  return (
    <TableRow>
      <TableCell padding="checkbox">
        <Checkbox
          checked={selectedEmployees.includes(token)}
          onChange={event => toggleSelection(event.target.checked, token)}
        />
      </TableCell>

      <TableCell>
        <Box sx={{ display: 'flex', gap: 2 }}>
          <ErrorIndicator
            tooltipTitle={t('employees:employees.noGroupTooltip')}
            visible={!groupName}
            color="warning.secondary"
          />

          <Typography variant="inherit">{email || '-'}</Typography>
        </Box>
      </TableCell>

      <TableCell>
        <EmployeeInvitationState invitationState={status} />
      </TableCell>

      <TableCell>
        {groupName ? (
          <Typography variant="body2">{groupName}</Typography>
        ) : (
          <Typography variant="body2" color="textSecondary">
            {t('employees:employees.groupNotAssigned')}
          </Typography>
        )}
      </TableCell>

      <TableCell align="right" sx={{ cursor: 'default' }}>
        {actionsSlot({ token, email, employeeGroupToken })}
      </TableCell>
    </TableRow>
  );
};

export default EmployeesTableRow;
